/**
 * Deactivate selected project(s)
 */
$(function(){
    $('#buttonDeactivateSelection').click(function(){
        var type = $('#buttonDeactivateSelection').val();
        var arrayLength = selectedDatagridData.length;
        var selectedItems = [];
        for(var i = 0; i < arrayLength; i++)
        {
            selectedItems.push(selectedDatagridData[i].id);
        }

        $('#deactivateIds').val(selectedItems);
        $('#bulkDeactivateForm').attr('action', '/'+ type +'/bulkDeactivate'); // type = project or employee
        $('#bulkDeactivateModal').modal('show');
    });
});

/**
 * Activate selected project(s)
 */
$(function(){
    $('#buttonActivateSelection').click(function(){
        var type = $('#buttonActivateSelection').val();
        var arrayLength = selectedDatagridData.length;
        var selectedItems = [];
        for(var i = 0; i < arrayLength; i++)
        {
            selectedItems.push(selectedDatagridData[i].id);
        }

        $('#activateIds').val(selectedItems);
        $('#bulkActivateForm').attr('action', '/'+ type +'/bulkActivate'); // type = project or employee
        $('#bulkActivateModal').modal('show');
    });
});


// WEBPACK FOOTER //
// ./resources/js/components/bulkactions.js